import React, { useState, useEffect } from "react";
import { Typography, Box, Stack, Avatar } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";

import { Images } from "./../../assets/common";
import { useHistory } from "react-router-dom";
import DoneIcon from "@mui/icons-material/Done";
import { fullName, isOwnerId, generateDynamicLink, copyToClipboard } from "./../../constants/function";
import { addSongAction } from "./../../action/songs";
import { useSelector, useDispatch } from "react-redux";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ProfileMenu from "../ProfileMenu";
import AddMusicToPlaylist from "../AddMusicToPlaylist";
import OutsideClickHandler from "react-outside-click-handler";
import MusicCard from "../MusicCard";
import notifier from "../Notifier";
import { useTranslation } from "react-i18next";
import "./index.scss";
import VerificationSVG from './../../assets/common/artistProfile/Verification.svg';

export default function SearchResult({
  users,
  musics,
  playlists,
  handleClose,
  keyword,
  onShowAddPlaylist,
}) {
  const { t } = useTranslation("common");
  const [open, setOpen] = React.useState(false);
  const [selectedIndex, setSelectedIndex] = React.useState(null);
  const [selectedId, setSelectedAlbum] = React.useState();

  const songs = useSelector((state) => state.songs);
  const previousSong = React.useRef(songs);
  const dispatch = useDispatch();
  const history = useHistory();
  const [showPlaylist, setShowPlaylist] = React.useState(false);

  const [isQueryEmpty, setIsQueryEmpty] = useState(true);

  useEffect(() => {
    setIsQueryEmpty(keyword.trim() === "");
  }, [keyword]);

  const toggleDrawer = async (value, id, index, song) => {
    setOpen(value);
    setSelectedIndex(index);
    if (value && id) {
      setOpen(false);
      await makeAction(value, id, index, song);
    }
  };
  const makeAction = async (key, id, index, song) => {
    switch (key) {
      case "m2":
        if (
          !isOwnerId(
            song["owner"]
              ? song["owner"]["_id"]
              : song["uploader"]
              ? song["uploader"]["_id"]
              : ""
          ) &&
          song["private"] &&
          ((song["owner"] && !song["owner"]["isSubscribed"]) ||
            (song["uploader"] && !song["uploader"]["isSubscribed"]))
        )
          notifier.error(t("notifier.error.toast5"));
        else {
          dispatch(addSongAction(musics[index], null, true));
          handleClose();
        }
        break;
      case "m3":
        if (
          !isOwnerId(
            song["owner"]
              ? song["owner"]["_id"]
              : song["uploader"]
              ? song["uploader"]["_id"]
              : ""
          ) &&
          song["private"] &&
          ((song["owner"] && !song["owner"]["isSubscribed"]) ||
            (song["uploader"] && !song["uploader"]["isSubscribed"]))
        )
          notifier.error(t("notifier.error.toast5"));
        else {
          onShowAddPlaylist(id, true);
          handleClose();
        }
        break;
      case "m1":
        handleClose();
        song["nftId"]
          ? history.push(`/app/SongDetail/${song["nftId"]}`)
          : history.push(`/app/SongDetail/${id}`);
        break;
      case "m14":
        // Share song - copy link
        const thumbnail = song.GIF?.filePath || song.thumbnailImg?.filePath;
        const url = await generateDynamicLink('song', song._id, song.title, '', thumbnail);
        copyToClipboard(url);
        notifier.info(t("qrPopup.tooltip"));
        handleClose();
        break;
      default:
        break;
    }
  };

  const playSong = (song) => {
    if (
      !isOwnerId(
        song["owner"]
          ? song["owner"]["_id"]
          : song["uploader"]
          ? song["uploader"]["_id"]
          : ""
      ) &&
      song["private"] &&
      ((song["owner"] && !song["owner"]["isSubscribed"]) ||
        (song["uploader"] && !song["uploader"]["isSubscribed"]))
    )
      notifier.error(t("notifier.error.toast5"));
    else {
      handleClose();
      dispatch(addSongAction(song));
    }
    
    // ... (same logic as before)
  };

  // Check if there are any results before rendering the box
  const hasResults = musics.length > 0 || users.length > 0 || playlists.length > 0;

  console.log("[SearchResult] Rendering with:", {
    keyword,
    hasResults,
    musicsCount: musics.length,
    usersCount: users.length,
    playlistsCount: playlists.length,
    isQueryEmpty
  });

  // Add visual debugging
  if (hasResults && !isQueryEmpty) {
    console.log("[SearchResult] Should be visible with z-index 1000000001");
  }

  return (
    <Box className="__Search_result_box">
      {hasResults && !isQueryEmpty && (
        <Box
          className="__main_pading scroll_display"
          style={{
            maxHeight: "77vh",
            overflowY: "scroll",
            paddingBottom: "20px",
            justifyContent: "space-between", // Ensure even spacing between elements
            width: "100%", // Ensure the entire row takes up available width
          }}
        >
          {/* Music Section */}
          {musics && musics.length > 0 && (
            <Box className="search-section">
              <Box className="section-header">
                <Typography className="section-title">{t("searchResult.header1")}</Typography>
                <Typography
                  className="view-all"
                  onClick={() => {
                    handleClose();
                    history.push(`/app/searchMusic/${encodeURIComponent(keyword)}`);
                  }}
                >
                  {t("searchResult.all")}
                </Typography>
              </Box>
              <Box className="music_result">
                {musics.map((song, index) => (
                  <Box key={index} sx={{ position: "relative" }}>
                    <Box className="music-item">
                      <Box className="__music_thumb" onClick={() => playSong(song)}>
                        <Avatar src={song["thumbnailImg"] ? song["thumbnailImg"]["filePath"] : Images.dummy} />
                      </Box>
                      <Box className="music-info">
                        <Box className="music-title">
                          <Typography className="title-text">{song["title"]}</Typography>
                          {song["private"] && (
                            <LockIcon />
                          )}
                        </Box>
                        <Box className="music-artist">
                          {song.artistData ? (
                            <>
                              <Typography className="artist-name">
                                {song.artistData.map((a, idx) => (
                                  <span key={idx}>
                                    {a.displayArtistName}
                                    {idx !== song.artistData.length - 1 && ", "}
                                  </span>
                                ))}
                              </Typography>
                            </>
                          ) : (
                            <Typography className="artist-name">{fullName(song["uploader"])}</Typography>
                          )}
                          {song["uploader"]["isVerified"] && (
                            <img
                              src={VerificationSVG}
                              alt="Verified"
                              className="verification-icon"
                            />
                          )}
                        </Box>
                      </Box>
                      <MoreVertIcon
                        onClick={(e) => {
                          e.stopPropagation();
                          setOpen(!open);
                          setSelectedIndex(index);
                        }}
                        className="__more_hover_color"
                      />
                    </Box>
                    {open && selectedIndex === index && (
                      <OutsideClickHandler onOutsideClick={() => setOpen(false)}>
                        <ProfileMenu
                          right={"0px"}
                          open={open}
                          actions={[
                            { key: "m2", action: t("dropMenu.m2") },
                            { key: "m3", action: t("dropMenu.m3") },
                            { key: "m14", action: t("dropMenu.m14") },
                            { key: "m1", action: t("dropMenu.m1") },
                          ]}
                          handleProfileMenuChoice={(action) =>
                            toggleDrawer(action, song["_id"], index, song)
                          }
                        />
                      </OutsideClickHandler>
                    )}
                  </Box>
                ))}
              </Box>
            </Box>
          )}
  
          {/* Users Section */}
          {users && users.length > 0 && (
            <Box className="search-section">
              <Box className="section-header">
                <Typography className="section-title">{t("searchResult.header3")}</Typography>
                <Typography
                  className="view-all"
                  onClick={() => {
                    handleClose();
                    history.push(`/app/searchArtist/${encodeURIComponent(keyword)}`);
                  }}
                >
                  {t("searchResult.all")}
                </Typography>
              </Box>
              <Box className="artists-grid">
                {users.map((user, index) => (
                  <Box
                    key={index}
                    className="artist-card"
                    onClick={() => {
                      handleClose();
                      history.push(`/app/ArtistProfile/${user["_id"]}`);
                    }}
                  >
                    <Box className="__artist_thumbnail">
                      <img
                        className="__large_avatar"
                        src={user["profileImg"] ? user["profileImg"]["filePath"] : Images.default_user}
                        alt="user"
                      />
                    </Box>
                    <Box className="artist-name">
                      <Typography>{fullName(user)}</Typography>
                      {user["isVerified"] && (
                        <img
                          src={VerificationSVG}
                          alt="Verified"
                          className="verification-icon"
                        />
                      )}
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>
          )}
  
          {/* Playlist Section */}
          {playlists && playlists.length > 0 && (
            <Box className="search-section">
              <Box className="section-header">
                <Typography className="section-title">{t("searchResult.header2")}</Typography>
                <Typography
                  className="view-all"
                  onClick={() => {
                    handleClose();
                    history.push(`/app/searchStudio/${encodeURIComponent(keyword)}`);
                  }}
                >
                  {t("searchResult.all")}
                </Typography>
              </Box>
              <Box className="playlists-grid">
                {playlists.map((playlist, index) => (
                  <MusicCard
                    key={index}
                    isPlaylist={true}
                    music={playlist}
                    title="Featured Playlist"
                    route={"/app/feature/playlists"}
                    noActions={true}
                    platform={playlist?.playlistNftDetails?.platform}
                    actions={["Add all songs to Queue", "Mark this Asset Private", "View Statistics"]}
                    toggleMenu={(action, id, index) => toggleDrawer(action, id, index)}
                    onHistory={(isNft) => {
                      !isOwnerId(playlist["createdBy"]) &&
                      !playlist["isSubscribed"] &&
                      playlist["private"]
                        ? notifier.error("Subscribe the Artist to view the details")
                        : history.push(
                            `/app/${isNft ? "PlaylistNftDetail" : "Music"}/${
                              isNft ? playlist["nftId"] : playlist["_id"]
                            }`
                          );
                      handleClose();
                    }}
                    isSearch={true}
                  />
                ))}
              </Box>
            </Box>
          )}
        </Box>
      )}
  
      {showPlaylist && (
        <AddMusicToPlaylist
          musicId={selectedId}
          open={showPlaylist}
          handleClose={() => setShowPlaylist(false)}
        />
      )}
    </Box>
  );
}  